import { createContext, useMemo, useState } from 'react';
import * as React from 'react';

export enum View {
  editor = 'editor',
  display = 'display',
  songbook = 'songbook',
}

export enum SubMenu {
  download = 'download',
}

interface NavigationContextValue {
  currentView: View | string;
  currentSubMenu?: SubMenu | string | null;
  setCurrentView: (view: View | string) => void;
  setCurrentSubMenu: (subView?: SubMenu | string | null) => void;
}

export const NavigationContext = createContext<NavigationContextValue>({
  currentView: View.display,
  currentSubMenu: null,
  setCurrentView: () => {},
  setCurrentSubMenu: () => {},
});

export const NavigationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [currentView, setCurrentView] = useState<View>(View.songbook);
  const [currentSubMenu, setCurrentSubMenu] = useState<SubMenu>(null);

  const handleSetView = (newView: View) => {
    setCurrentView(newView);
    setCurrentSubMenu(null); // Reset subView when changing the main view
  };

  const handleSetSubView = (newSubView: SubMenu) => {
    setCurrentSubMenu(newSubView);
  };

  const contextValue: NavigationContextValue = useMemo(
    () => ({
      currentView,
      currentSubMenu,
      setCurrentView: handleSetView,
      setCurrentSubMenu: handleSetSubView,
    }),
    [currentView, currentSubMenu],
  );

  return <NavigationContext.Provider value={contextValue}>{children}</NavigationContext.Provider>;
};
